module.exports = __webpack_public_path__ + "img/logo.86405b88.png";